<template>
  <div class="setMydata">
    <el-form
      :model="ndividualObj"
      ref="ndividualObjForm"
      label-width="0px"
      class="demo-ruleForm"
      :rules="ndividualRules"
    >
      <div class="list">
        <div class="itemLeft">真实姓名</div>
        <div class="itemRight">
          <el-form-item prop="name">
            {{ ndividualObj.name }}
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">手机号码</div>
        <div class="itemRight">
          <el-form-item prop="mobile">
            {{ ndividualObj.mobile }}
            <!-- <el-input
              v-model="ndividualObj.mobile"
              placeholder="请输入手机号码"
              :disabled="true"
            ></el-input> -->
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">会员昵称</div>
        <div class="itemRight">
          <el-form-item prop="username">
            <el-input
              v-model="ndividualObj.username"
              placeholder="请输入会员昵称"
              size="mini"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">性别</div>
        <div class="itemRight">
          <el-form-item>
            <el-select v-model="ndividualObj.sex">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">民族</div>
        <div class="itemRight">
          <el-form-item prop="nation">
            <el-input
              v-model="ndividualObj.nation"
              placeholder="请输入民族"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">身份证</div>
        <div class="itemRight">
          <el-form-item prop="idcard">
            <el-input
              v-model="ndividualObj.idcard"
              placeholder="请输入身份证"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">邮箱</div>
        <div class="itemRight">
          <el-form-item prop="email">
            <el-input
              v-model="ndividualObj.email"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">专业</div>
        <div class="itemRight">
          <el-form-item prop="major">
            <el-input
              v-model="ndividualObj.major"
              placeholder="请输入专业"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">学历</div>
        <div class="itemRight">
          <el-form-item prop="education">
            <el-input
              v-model="ndividualObj.education"
              placeholder="请输入学历"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">工作单位</div>
        <div class="itemRight">
          <el-form-item prop="workUnit">
            <el-input
              v-model="ndividualObj.workUnit"
              placeholder="请输入工作单位"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">职位</div>
        <div class="itemRight">
          <el-form-item prop="job">
            <el-input
              v-model="ndividualObj.job"
              placeholder="请输入职位"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">技术职称</div>
        <div class="itemRight">
          <el-form-item prop="technicalTitle">
            <el-input
              v-model="ndividualObj.technicalTitle"
              placeholder="请输入技术职称"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">愿意被推荐加入专业委员会</div>
        <div class="itemRight">
          <el-form-item>
            <el-select v-model="ndividualObj.isWilling">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="list">
        <div class="itemLeft">收获地址</div>
        <div class="itemRight">
          <el-form-item prop="address">
            <el-input
              v-model="ndividualObj.address"
              placeholder="请输入快递地址"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="button" @click="editMemberInfo">修改资料</div>
    </el-form>
  </div>
</template>

<script>
import {
  getMemberInfo, // 获取
  editMemberInfo // 修改
} from "@/api/api.js";
export default {
  data() {
    const idRex = (rule, value, callback) => {
      let myreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value === "") {
        callback(new Error("请输入会员数量身份证ID"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的身份证ID"));
      } else {
        callback();
      }
    };
    const emailRex = (rule, value, callback) => {
      let myreg = /^([A-Za-z0-9_+-.])+@([A-Za-z0-9\-.])+\.([A-Za-z]{2,22})$/;
      if (value === "") {
        callback(new Error("请输入邮箱号码"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的邮箱号码"));
      } else {
        callback();
      }
    };
    return {
      // 个人
      ndividualObj: {
        userId: "",
        username: "",
        name: "",
        mobile: "",
        sex: "1", // 性别 1-男2-女,
        nation: "", //民族,
        // birth: "", //出生年月,
        idcard: "", //身份证,
        email: "", //邮箱,
        major: "", // 专业,
        education: "", //学历,
        job: "", //职位,
        technicalTitle: "", //技术职称,
        workUnit: "", //工作单位,
        isWilling: "1", //愿意被推荐加入的专业委员会 1-愿意 2-不愿意,
        address: "" //快递地址,
        // mediaId: "" // file类型 个人免冠照,
      },
      ndividualRules: {
        username: [{ required: true, message: "请输入会员昵称" }],
        name: [{ required: true, message: "请输入真实姓名" }],
        nation: [{ required: true, message: "请输入民族" }], //民族,
        idcard: [{ validator: idRex }], //身份证,
        email: [{ validator: emailRex }], //邮箱,
        major: [{ required: true, message: "请输入专业" }], // 专业,
        education: [{ required: true, message: "请输入学历" }], //学历,
        job: [{ required: true, message: "请输入职位" }], //职位,
        technicalTitle: [{ required: true, message: "请输入技术职称" }], //技术职称,
        workUnit: [{ required: true, message: "请输入工作单位" }], //工作单位,
        address: [{ required: true, message: "请输入快递地址" }] //快递地址,
      }
    };
  },
  created() {
    const ListObj = JSON.parse(window.sessionStorage.getItem("userList"));
    this.ndividualObj.userId = ListObj.id;
    this.ndividualObj.username = ListObj.name;
    this.getMemberInfo(this.ndividualObj.userId);
  },
  methods: {
    getMemberInfo(id) {
      getMemberInfo(id).then(res => {
        if (res.code === 0) {
          // this.ndividualObj = res.data;
          Object.assign(this.ndividualObj, res.data);
          this.ndividualObj.sex = `${this.ndividualObj.sex}`;
          this.ndividualObj.isWilling = `${this.ndividualObj.isWilling}`;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    editMemberInfo() {
      this.$refs.ndividualObjForm.validate(valid => {
        if (valid) {
          editMemberInfo(this.ndividualObj).then(res => {
            if (res.code === 0) {
              // console.log(res, 'res-----------------');
              this.$message({
                message: "修改成功",
                type: "success"
              });
              this.$router.push({ name: "H5my" });
              // window.open('http://www.shhhxh.com/hhxh/api/wechat/memberRegister');
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less">
.setMydata {
  width: 100%;
  // height: 100px;
  // background: red;
  padding: 16px;
  box-sizing: border-box;
  .list {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    height: 40px;
    margin-top: 20px;
    border-bottom: 1px solid #e6e6e6;
    .itemLeft {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
    }
    .el-select {
      width: 66px;
    }
    .el-input__inner {
      border: none;
      text-align: right;
    }
    .el-form-item__error {
      right: 10px;
      left: inherit;
    }
  }
  .button {
    margin: 50px auto 30px;
    width: 320px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #6c2c66;
    border-radius: 4px;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>
